import Vue from "vue";
import Router from "vue-router";
import rsv from "./../components/reservation/ReservationContainer.vue";

Vue.use(Router);

/*eslint-disable*/
const routes = [
  {
    name: "reservation",
    path: "/store/:storeid/reservation",
    props: true,
    component: rsv,
    meta: {
      layout: "full"
    }
  }
];
/*eslint-disable*/
const router = new Router({
  routes: routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

export default router;
